import React, { useState, useCallback, useEffect, useRef } from "react";
import ContentWrapper from "../../../../components/common/ContentWrapper";
import Card from "../../../../components/common/Card";
import CardHeader from "../../../../components/common/CardHeader";
import CardBody from "../../../../components/common/CardBody";
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import PaperFilterLayout from "../../paper/edsider/TheFilter/PaperFilterLayout";
import { EMPLOYEE_FILTERS } from "../../../../helper/constants";
import StickyCardBody from "../../../../components/common/StickyCardBody";
import TabList from "../../../../components/common/tabs/TabList";
import NavItem from "../../../../components/common/tabs/NavItem";
import ReactForm from "react-bootstrap/Form";
import TabContent from "../../../../components/common/tabs/TabContent";
import TabPane from "../../../../components/common/tabs/TabPane";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  IconButton,
} from "@mui/material";
import ReactSpinner from "react-bootstrap/Spinner";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination";
import { studentUserActions } from "../../../../actions/user_management/studentUserActions";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import { Form, Row, Col, Spinner, Button, Image } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { assessmentService } from "../../../../service/assessment/assessmentService";
import "./userReports.css";
import { use } from "react";

function UserReports() {
  const dispatch = useDispatch();

  const [assMetaData, setAssmentMetaData] = useState({
    allCategories: [],
    allLanguages: [],
    allSubjects: [],
    allYears: [],
    allDifficulties: [],
    allGrades: [],
    allTerms: [],
    allChapters: [],
    allCurrencyTypes: [],
  });

  const [state, setState] = useState({
    offset: 0,
    rowsPerPage: 50,
    sort_column: "last_seen",
    sort_direction: "desc",
    search_term: "",
    selectedGrades: [],
    selectedLanguages: [],
    selectedStartDate: null,
    selectedEndDate: null,
    selectedExamCategories: [],
    selectedChapters: [],
    selectedDifficulties: [],
    selectedTerms: [],
    selectedYears: [],
    selectedSubjects: [],
    selectedStatuses: [],
    selectedExamCategories: [],
    selectedCategories: null,
    selectedAuthors: null,
    is_signin_dates_select: "false",
    currentPage: 0,
  });
  const [studentPaperEnrolment, setStudentPaperEnrolment] = useState({
    assessments: [],
    totalAssessmentCount: 0,
  });
  const [studentsDetails, setStudentsDetails] = useState({
    students: [],
    totalStudentCount: 0,
  });

  const [paperEnrolStatusCounts, setPaperEnrolStatusCounts] = useState({
    papers: [],
    totalPaperCount: 0,
  });
  const [paperDetails, setPaperDetails] = useState({
    paper_details: [],
  });
  const [assStudentDetails, setAssStudentDetails] = useState({
    students: [],
  });

  const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Sign-in Details");
  const [searchQuery, setSearchQuery] = useState("");
  const mountedRef = useRef(true);

  const [assessmentModalShow, setAssessmentModelShow] = useState(false);
  const [studentModelShow, setStudentModelShow] = useState(false);
  const [modelDataLoding, setModelDataLoding] = useState(false);

  const [feedbackModalShow, setFeedbackModalShow] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const [feedback, setFeedback] = useState({
    feedbacks: [],
    feedback_questions: [],
    feedback_answer_options: [],
    totalFeedbackCount: 0,
  });

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const fetchStudents = async () => {
      setIsTableDataLoading(true);
      try {
        if (activeTab === "Student Enroll Details") {
          const assessmentMetaDataResponse =
            await assessmentService.getAllAssessmentMetaData();
          if (assessmentMetaDataResponse.success) {
            setAssmentMetaData((pre) => ({
              ...pre,
              allCategories:
                assessmentMetaDataResponse.data.find(
                  (item) => "categories" in item,
                )?.categories || [],
              allLanguages:
                assessmentMetaDataResponse.data.find(
                  (item) => "languages" in item,
                )?.languages || [],
              allSubjects:
                assessmentMetaDataResponse.data.find(
                  (item) => "subjects" in item,
                )?.subjects || [],
              allYears:
                assessmentMetaDataResponse.data.find((item) => "years" in item)
                  ?.years || [],
              allDifficulties:
                assessmentMetaDataResponse.data.find(
                  (item) => "difficulty_types" in item,
                )?.difficulty_types || [],
              allGrades:
                assessmentMetaDataResponse.data.find((item) => "grades" in item)
                  ?.grades || [],
              allTerms:
                assessmentMetaDataResponse.data.find((item) => "terms" in item)
                  ?.terms || [],
              allChapters:
                assessmentMetaDataResponse.data.find(
                  (item) => "chapters" in item,
                )?.chapters || [],
              allCurrencyTypes:
                assessmentMetaDataResponse.data.find(
                  (item) => "currency_types" in item,
                )?.currency_types || [],
            }));
          }

          const res = await dispatch(
            studentUserActions.get_student_paper_enrol_status_counts(state),
          );
          const papers = res?.students ?? [];
          if (cancelled || !mountedRef.current) return;
          setPaperEnrolStatusCounts({
            papers,
            totalPaperCount: res?.count ?? 0,
          });
        } else if (activeTab === "Paper Enroll Details") {
          const result = await dispatch(
            studentUserActions.get_paper_enroled_student_counts(state),
          );
          if (cancelled || !mountedRef.current) return;
          const assessments = result?.assessments;

          const totalAssessmentCount = result?.total_count || 0;
          if (cancelled || !mountedRef.current) return;
          setStudentPaperEnrolment({
            assessments: assessments,
            totalAssessmentCount: totalAssessmentCount,
          });
        } else if (activeTab === "Assessment Feedback") {
          const fetchFeedback = async () => {
            setIsTableDataLoading(true);
            try {
              const res = await assessmentService.get_all_feedbacks(state);
              if (cancelled || !mountedRef.current) return;
              const feedbacks = res?.data?.feedbacks ?? [];
              if (mountedRef.current) {
                setFeedback({
                  feedbacks,
                  feedback_questions: res?.data?.feedback_questions ?? [],
                  feedback_answer_options:
                    res?.data?.feedback_answer_options ?? [],
                  totalFeedbackCount: res?.data?.count ?? 0,
                });
              }
            } catch (err) {
              console.error("Error fetching feedbacks:", err);
            } finally {
              if (mountedRef.current) setIsTableDataLoading(false);
            }
          };

          fetchFeedback();
        } else if (activeTab === "Sign-in Details") {
          const res = await dispatch(studentUserActions.getAllStudents(state));
          const students = res?.students ?? [];
          if (cancelled || !mountedRef.current) return;
          setStudentsDetails({
            students,
            totalStudentCount: res?.count ?? 0,
          });
        } else {
          const res = await dispatch(studentUserActions.getAllStudents(state));
          const students = res?.students ?? [];
          if (cancelled || !mountedRef.current) return;
          setStudentsDetails({
            students,
            totalStudentCount: res?.count ?? 0,
          });
        }
      } catch (err) {
        console.error("Error fetching student(s):", err);
      } finally {
        if (!cancelled && mountedRef.current) setIsTableDataLoading(false);
      }
    };

    fetchStudents();

    return () => {
      cancelled = true;
    };
  }, [state, activeTab, dispatch]);

  const handlePageChange = useCallback((event, newPage) => {
    setState((prevState) => {
      const newOffset = newPage * prevState.rowsPerPage;
      return {
        ...prevState,
        currentPage: newPage,
        offset: newOffset,
      };
    });
  }, []);

  const handleRowsPerPageChange = useCallback((event) => {
    const newLimit = parseInt(event.target.value, 10) || 10;
    setState((prevState) => ({
      ...prevState,
      rowsPerPage: newLimit,
      currentPage: 0,
      offset: 0,
    }));
  }, []);

  const handlePageOffsetChange = useCallback((newOffset, newPage) => {
    setState((prevState) => ({
      ...prevState,
      offset: newOffset,
      currentPage: newPage,
    }));
  }, []);

  const handleFilterChange = (newSelectedFilters) => {
    const getOrNull = (key) =>
      newSelectedFilters?.[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    setState((prev) => ({
      ...prev,
      selectedGrades: getOrNull("Grade"),
      selectedsubjects: getOrNull("Subject"),
      selectedCategories: getOrNull("Category"),
      selectedAuthors: getOrNull("Author"),
      selectedChapters: getOrNull("Chapter"),
      selectedDifficulties: getOrNull("Difficulty"),
      selectedLanguages: getOrNull("Language"),
      selectedYears: getOrNull("Year"),
      selectedTerms: getOrNull("Term"),
      selectedStatuses: getOrNull("Status"),
      selectedReviewers: getOrNull("Reviewers"),
      selectedExamCategories: getOrNull("Exam_Category"),
      selectedStartDate: getOrNull("StartDate"),
      selectedEndDate: getOrNull("EndDate"),
      selectedYears: getOrNull("Year"),
      offset: 0,
      currentPage: 0,
    }));
  };

  const debouncedUpdateStateSearch = useRef(
    debounce((searchTerm) => {
      setState((prevState) => {
        const safeLimit = prevState.rowsPerPage || 10;
        return {
          ...prevState,
          search_term: searchTerm,
          offset: 0,
          currentPage: 0,
          rowsPerPage: safeLimit,
        };
      });
    }, 300),
  ).current;

  useEffect(() => {
    return () => {
      debouncedUpdateStateSearch.cancel();
    };
  }, [debouncedUpdateStateSearch]);

  const handleSearchInputChange = (e) => {
    const value = (e?.target?.value ?? "").toString();
    setSearchQuery(value);

    const trimmed = value.trim();
    const regex = /^[\p{L}\p{M}\p{N}\p{P}\p{S}\s]*$/u;

    if (trimmed === "" || regex.test(trimmed)) {
      debouncedUpdateStateSearch(trimmed);
    } else {
      setState((prevState) => ({
        ...prevState,
        search_term: trimmed,
      }));
    }
  };

  const filteredStudents = (studentsDetails.students || []).filter((stu) => {
    const queryWords = searchQuery.toLowerCase().trim().split(" ");
    const fullName = `${stu.first_name ?? ""} ${
      stu.last_name ?? ""
    }`.toLowerCase();

    return queryWords.every(
      (word) =>
        fullName.includes(word) ||
        (stu.stu_id ?? "").toString().toLowerCase().includes(word) ||
        (stu.user_code ?? "").toString().toLowerCase().includes(word),
    );
  });

  const filteredPapers = (paperEnrolStatusCounts.papers || []).filter(
    (paper) => {
      const queryWords = searchQuery.toLowerCase().trim().split(" ");
      const fullName = `${paper.first_name ?? ""} ${
        paper.last_name ?? ""
      }`.toLowerCase();

      return queryWords.every(
        (word) =>
          fullName.includes(word) ||
          (paper.stu_id ?? "").toString().toLowerCase().includes(word) ||
          (paper.user_code ?? "").toString().toLowerCase().includes(word),
      );
    },
  );

  const filteredStudentEnrolments = (
    studentPaperEnrolment.assessments || []
  ).filter((assessment) => {
    const queryWords = searchQuery.toLowerCase().trim().split(" ");
    const assessName = (assessment.assess_name || "").toLowerCase();
    const assessmentName = (assessment.assessment_name || "").toLowerCase();
    const assessmentIdStr = (assessment.assessment_id || "")
      .toString()
      .toLowerCase();
    const assessmentIdPattern = `asmnt${assessmentIdStr}`;
    return queryWords.every(
      (word) =>
        assessName.includes(word) ||
        assessmentIdPattern.includes(word) ||
        assessmentName.includes(word),
    );
  });
  const toggleFilter = useCallback(() => {
    setIsFilterCollapsed((prev) => !prev);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}/${month}/${day}`;
  };

  const formatTime = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleTimeString("en-US");
  };
  const formatTimeForSignUp = (dateString) => {
    if (!dateString) return "";

    // Convert "2025-08-15 11:55:15.414066" → "2025-08-15T11:55:15.414066Z"
    const isoString = dateString.replace(" ", "T") + "Z";

    const d = new Date(isoString);

    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Asia/Colombo",
    }).format(d);
  };

  const getUniqueAssessments = () => {
    const unique = {};
    feedback.feedbacks.forEach((fb) => {
      if (!unique[fb.assessment_id]) {
        unique[fb.assessment_id] = {
          assessment_id: fb.assessment_id,
          paper_title: fb.paper_title,
          template_name: fb.template_name,
          feedbackCount: 0,
        };
      }
      unique[fb.assessment_id].feedbackCount += 1;
    });
    return Object.values(unique);
  };

  const handleAssessmentClick = (assessment) => {
    setSelectedAssessment(assessment);
    setSelectedQuestion(null);
    setFeedbackModalShow(true);
  };

  const getQuestionsForAssessment = (assessmentId) => {
    const selectedFeedbacks = feedback.feedbacks.filter(
      (fb) => fb.assessment_id === assessmentId,
    );
    const allQuestions = (feedback.feedback_questions || [])
      .slice()
      .sort((a, b) => (a.qus_id || 0) - (b.qus_id || 0));

    const askedQuestionIds = new Set(
      selectedFeedbacks.map((fb) => fb.feedback_question_id),
    );
    const questionsInAssessment =
      askedQuestionIds.size > 0
        ? allQuestions.filter((q) => askedQuestionIds.has(q.qus_id))
        : allQuestions;

    return questionsInAssessment.map((q, idx) => {
      const feedbacksForQuestion = selectedFeedbacks.filter(
        (fb) => fb.feedback_question_id === q.qus_id,
      );

      // Check if this question has text input responses
      const hasTextResponses = feedbacksForQuestion.some((fb) => fb.answer_text);

      const optionsForQuestion = (feedback.feedback_answer_options || [])
        .filter((opt) => opt.qus_id === q.qus_id)
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
        .map((opt) => {
          const count = feedbacksForQuestion.filter(
            (fb) =>
              fb.feedback_question_id === q.qus_id &&
              fb.feedback_answer_option_id === opt.fb_qus_ans_opt_id,
          ).length;
          return {
            ...opt,
            count,
          };
        });

      const filteredOptions = optionsForQuestion;
      const total = feedbacksForQuestion.length;

      return {
        qus_id: q.qus_id,
        index: idx + 1,
        question: q.qus_content || q.question || `Question ${idx + 1}`,
        options: filteredOptions,
        total,
        hasTextResponses,
      };
    });
  };

  const getFeedbackOptionThemeClass = () => "feedback-chip--yellow";

  const getFeedbacksForQuestion = () => {
    if (!selectedAssessment || !selectedQuestion) return [];
    return feedback.feedbacks.filter(
      (fb) =>
        fb.assessment_id === selectedAssessment.assessment_id &&
        fb.feedback_question_id === selectedQuestion.qus_id,
    );
  };

  const viewStudentAssessmentDetail = async (studentId) => {
    try {
      setAssessmentModelShow(true); //model open------------------->popup page
      setModelDataLoding(true);
      const res = await dispatch(
        studentUserActions.get_student_paper_details(studentId),
      );
      setPaperDetails({ paper_details: res?.assessments || [] });
    } catch (err) {
      console.error("Failed to fetch paper details:", err);
    } finally {
      setModelDataLoding(false);
    }
  };

  const viewAssessmentStudentDetail = async (assessmentId) => {
    try {
      setStudentModelShow(true); //model open------------------->popup page
      setModelDataLoding(true);
      const res = await dispatch(
        studentUserActions.get_assessment_student_details(assessmentId),
      );
      setAssStudentDetails({ students: res?.students || [] });
    } catch (err) {
      console.error("Failed to fetch student details:", err);
    } finally {
      setModelDataLoding(false);
    }
  };

  const UserOwnPaper = () => {
    const [expandedItem, setExpandedItem] = useState(null);

    const toggleExpand = (idx) => {
      setExpandedItem((prev) => (prev === idx ? null : idx));
    };

    const statusDisplayName = {
      assigned: "Not Started",
      assign: "Not Started",
      pending: "Pending",
      inprogress: "In Progress",
      completed: "Completed",
      rejected: "Rejected",
    };
    const papers = paperDetails?.paper_details || [];
    if (papers.length === 0) {
      return <p className="text-muted">No assessments enrolled.</p>;
    }

    return (
      <div
        className="cart-scroll-box"
        style={{ maxHeight: "60vh", overflowY: "auto" }}
      >
        {papers.map((p, idx) => {
          const assessment_id = p.assessment_id;
          const examTitle = p.assess_name || "Untitled ";
          const candidate_status = p.candidate_status || "N/A";
          const subject =
            assMetaData.allSubjects.find((s) => s.subject_id == p.subject_id)
              ?.subject || "N/A";
          const grade =
            assMetaData.allGrades.find((g) => g.grade_id == p.grade_id)
              ?.grade || "N/A";
          const language =
            assMetaData.allLanguages.find((l) => l.language_id == p.language_id)
              ?.language || "N/A";
          const difficulty =
            assMetaData.allDifficulties.find(
              (d) => d.difficulty_id == p.difficulty_id,
            )?.difficulty_type || "N/A";
          const category =
            assMetaData.allCategories.find(
              (a) => a.category_id == p.exam_category_id,
            )?.name || "N/A";
          const amount = p.amount || "Free";
          const enrolled_date = new Date(p.enrolled_time)
            .toISOString()
            .split("T")[0];
          const no_of_credits = p.no_of_credits || "-";

          return (
            <Row key={p.assessment_id || idx} className="paper-row">
              <label className="paper-label">
                {/* Hidden checkbox controls dropdown */}
                <input
                  type="checkbox"
                  checked={expandedItem === idx}
                  onChange={() => toggleExpand(idx)}
                  className="paper-checkbox"
                />

                {/* Row header */}
                <div className="paper-title">
                  <div className="exam-title">{examTitle}</div>

                  <div
                    className={`candidate-status ${candidate_status?.toLowerCase()}`}
                  >
                    {statusDisplayName[candidate_status?.toLowerCase()] ||
                      candidate_status}
                  </div>

                  <div
                    className={`arrow ${expandedItem === idx ? "open" : ""}`}
                  >
                    ▼
                  </div>
                </div>

                {/* Dropdown content */}
                <div
                  className={`paper-details ${
                    expandedItem === idx ? "open" : ""
                  }`}
                >
                  <div>
                    <strong>Assessment Id:</strong>
                    {"ASMNT"}
                    {assessment_id}
                  </div>
                  {amount > 0 && (
                    <div>
                      <strong>amount:</strong> {amount}
                      {".00"}
                    </div>
                  )}
                  {no_of_credits > 0 && (
                    <div>
                      <strong>No of credit :</strong>
                      {no_of_credits}
                    </div>
                  )}
                  <div>
                    <strong>Subject:</strong> {subject}
                  </div>
                  <div>
                    <strong>Grade:</strong> {grade}
                  </div>
                  <div>
                    <strong>Language:</strong> {language}
                  </div>
                  <div>
                    <strong>Enrolled Date:</strong>
                    {enrolled_date}
                  </div>
                  {difficulty && (
                    <div>
                      <strong>Difficulty:</strong> {difficulty}
                    </div>
                  )}
                  {category && (
                    <div>
                      <strong>Category:</strong> {category}
                    </div>
                  )}
                  {p.score != null && (
                    <div>
                      <strong>Score:</strong> {p.score}
                    </div>
                  )}
                  {p.attempted_at && (
                    <div>
                      <strong>Attempted On:</strong>{" "}
                      {formatDate(p.attempted_at)}
                    </div>
                  )}
                </div>
              </label>
            </Row>
          );
        })}
      </div>
    );
  };

  const AssessmentOwnStudents = () => {
    const [expandedItem, setExpandedItem] = useState(null);

    const toggleExpand = (idx) => {
      setExpandedItem((prev) => (prev === idx ? null : idx));
    };

    const statusDisplayName = {
      assigned: "Not Started",
      assign: "Not Started",
      pending: "Pending",
      inprogress: "In Progress",
      completed: "Completed",
      rejected: "Rejected",
    };

    const getGenderLabel = (genderId) => {
      if (!genderId) return "-";
      return genderId == 1 ? "Male" : genderId === 2 ? "Female" : "-";
    };

    const students = assStudentDetails?.students || [];

    if (students.length === 0) {
      return <p className="text-muted">No student enrolled.</p>;
    }

    return (
      <div
        className="cart-scroll-box"
        style={{ maxHeight: "60vh", overflowY: "auto" }}
      >
        {students.map((s, idx) => {
          const user_code = s.user_code;
          const first_name = s.first_name || " - ";
          const last_name = s.last_name || "-";
          const grade =
            assMetaData.allGrades.find((g) => g.grade_id == s.grade)?.grade ||
            "-";
          const email = s.email || "-";
          const gender_id = s.gender_id || "-";
          const phone_numbe = s.phone_number || "-";
          const school = s.school || "-";
          const candidate_status = s.candidate_status;
          const enrolled_date = formatDate(s.enrolled_time);
          const last_login = formatDate(s.last_seen);

          return (
            <Row key={s.student_id || idx} className="paper-row">
              <label className="paper-label">
                {/* Hidden checkbox controls dropdown */}
                <input
                  type="checkbox"
                  checked={expandedItem === idx}
                  onChange={() => toggleExpand(idx)}
                  className="paper-checkbox"
                />

                {/* Row header */}
                <div className="paper-title">
                  <div className="user-code">{user_code}</div>
                  <div className="exam-title">
                    {first_name} {last_name}
                  </div>

                  <div
                    className={`candidate-status ${candidate_status?.toLowerCase()}`}
                  >
                    {statusDisplayName[candidate_status?.toLowerCase()] ||
                      candidate_status}
                  </div>

                  <div
                    className={`arrow ${expandedItem === idx ? "open" : ""}`}
                  >
                    ▼
                  </div>
                </div>

                {/* Dropdown content */}
                <div
                  className={`paper-details ${
                    expandedItem === idx ? "open" : ""
                  }`}
                >
                  <div>
                    <strong>Email: </strong>
                    {email}
                  </div>
                  <div>
                    <strong>Grade: </strong>
                    {grade}
                  </div>
                  <div>
                    <strong>Phone Numbe: </strong>
                    {phone_numbe}
                  </div>
                  <div>
                    <strong>Gender: </strong> {getGenderLabel(gender_id)}
                  </div>
                  <div>
                    <strong>School: </strong>
                    {school}
                  </div>
                  <div>
                    <strong>Enrolled Date: </strong>
                    {enrolled_date}
                  </div>
                  <div>
                    <strong>Last Login: </strong>
                    {last_login}
                  </div>
                </div>
              </label>
            </Row>
          );
        })}
      </div>
    );
  };

  return (
    <div style={{ height: "90vh", overflow: "auto" }}>
      <ContentWrapper>
        <Card>
          <CardHeader>
            <h1 className="mb-0">Student Report</h1>
          </CardHeader>

          <CardBody>
            <div className="thepapers-wrapper">
              <div className="col-md-12 px-0">
                <div style={{ padding: 12 }}>
                  <StickyCardBody>
                    <div className="user-reports-header-row">
                      <div className="user-reports-tabs-col">
                        <TabList>
                              <NavItem
                                className={`nav-link ${
                                  activeTab === "Sign-in Details"
                                    ? "active"
                                    : ""
                                }`}
                                id="manage-tab-1"
                                href="#manage-1"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Sign-in Details"
                                onClick={() => {
                                  setActiveTab("Sign-in Details");
                                  setState((prev) => ({
                                    ...prev,
                                    sort_column: "last_seen",
                                    sort_direction: "desc",
                                    is_signin_dates_select: "true",
                                  }));
                                }}
                              />
                              <NavItem
                                className={`nav-link ${
                                  activeTab === "Sign-up Details"
                                    ? "active"
                                    : ""
                                }`}
                                id="manage-tab-2"
                                href="#manage-2"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Sign-up Details"
                                onClick={() => {
                                  setActiveTab("Sign-up Details");
                                  setState((prev) => ({
                                    ...prev,
                                    sort_column: "created_at",
                                    sort_direction: "desc",
                                    is_signin_dates_select: "false",
                                  }));
                                }}
                              />
                              <NavItem
                                className={`nav-link ${
                                  activeTab === "Student Enroll Details"
                                    ? "active"
                                    : ""
                                }`}
                                id="manage-tab-3"
                                href="#manage-3"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Student Enroll Details"
                                onClick={() =>{
                                  setActiveTab("Student Enroll Details");
                                  setState((prev) => ({
                                    ...prev,
                                    sort_column: "enrolled_time",
                                    sort_direction: "desc",
                                  }));
                                }}
                              />
                              <NavItem
                                className={`nav-link ${
                                  activeTab === "Paper Enroll Details"
                                    ? "active"
                                    : ""
                                }`}
                                id="manage-tab-4"
                                href="#manage-4"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Paper Enroll Details"
                                onClick={() =>{
                                  setActiveTab("Paper Enroll Details");
                                  setState((prev) => ({
                                    ...prev,
                                    sort_column: "enrolled_time",
                                    sort_direction: "desc",
                                  }));
                                }}
                              />
                              <NavItem
                                className={`nav-link ${
                                  activeTab === "Assessment Feedback"
                                    ? "active"
                                    : ""
                                }`}
                                id="manage-tab-5"
                                href="#manage-5"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Assessment Feedback"
                                onClick={() =>{
                                  setActiveTab("Assessment Feedback");
                                }}
                              />
                        </TabList>
                      </div>
                      <div className="user-reports-search-col">
                        <ReactForm.Group
                          controlId="searchInput"
                          className="mb-0 user-reports-search-group"
                        >
                          <span className="user-reports-search-icon" aria-hidden="true">
                            <SearchRoundedIcon fontSize="small" />
                          </span>
                          <ReactForm.Control
                            className="user-reports-search-input"
                            type="text"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                          />
                        </ReactForm.Group>
                      </div>
                    </div>
                  </StickyCardBody>

                  <div className="filter-container mt-3">
                    {!isFilterCollapsed &&
                      activeTab !== "Paper Enroll Details" &&
                      activeTab !== "Assessment Feedback" && (
                        <PaperFilterLayout
                          userType={"DEOP"}
                          onFilterChange={handleFilterChange}
                          filterKeys={EMPLOYEE_FILTERS.UserReports}
                          isShowExamStatus={false}
                        />
                      )}
                    {!isFilterCollapsed &&
                      (activeTab === "Paper Enroll Details" ||
                        activeTab === "Assessment Feedback") && (
                        <PaperFilterLayout
                          userType={"DEOP"}
                          onFilterChange={handleFilterChange}
                          filterKeys={EMPLOYEE_FILTERS.studentEnrolDetails}
                          isShowExamStatus={false}
                        />
                      )}
                  </div>

                  <TabContent>
                    {/*-----------------------------------------------Sign-in Details------------------------------------------------- */}
                    {activeTab === "Sign-in Details" && (
                      <TabPane
                        className="tab-pane fade show active"
                        id="manage-1"
                        ariaLabelledby="manage-tab-1"
                        style={{ marginLeft: "0px"}}
                      >
                        {/* Table layout kept for reference
                        <Table>...</Table>
                        */}
                        <div className="modern-list-wrap">
                          <div className="modern-list modern-list-3">
                            <div className="modern-list-header modern-grid modern-grid-3">
                              <div>Student ID</div>
                              <div>Student Name</div>
                              <div>Last Login</div>
                            </div>
                            {isTableDataLoading ? (
                              <div className="modern-list-state">
                                <ReactSpinner animation="border" />
                              </div>
                            ) : filteredStudents.length > 0 ? (
                              filteredStudents.map((stu) => (
                                <div
                                  className="modern-list-row modern-grid modern-grid-3"
                                  key={stu.stu_id ?? stu.user_code}
                                >
                                  <div>{stu.user_code ?? stu.stu_id}</div>
                                  <div>
                                    {`${stu.first_name ?? ""} ${
                                      stu.last_name ?? ""
                                    }`.trim()}
                                  </div>
                                  <div>
                                    {formatDate(stu.last_seen)}{" "}
                                    <span style={{ color: "#3b82f6" }}>
                                      {formatTime(stu.last_seen)}
                                    </span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="modern-list-state">No data found</div>
                            )}
                          </div>
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                          <MaterialCustomTablePagination
                            totalCount={studentsDetails.totalStudentCount}
                            currentPage={state.currentPage}
                            limit={state.rowsPerPage}
                            handlePageChange={handlePageChange}
                            handleRowsPerPageChange={handleRowsPerPageChange}
                            handlePageOffsetChange={handlePageOffsetChange}
                            offset={state.offset}
                            rowsPerPageOptions={[
                              5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250,
                              300,
                            ]}
                          />
                        </div>
                      </TabPane>
                    )}
                        {/*-----------------------------------------------Sign-up Details------------------------------------------------- */}
                        {activeTab === "Sign-up Details" && (
                          <TabPane
                            className="tab-pane fade show active"
                            id="manage-2"
                            ariaLabelledby="manage-tab-2"
                          >
                            {/* Table layout kept for reference
                            <Table>...</Table>
                            */}
                            <div className="modern-list-wrap">
                              <div className="modern-list modern-list-3">
                                <div className="modern-list-header modern-grid modern-grid-3">
                                  <div>Student ID</div>
                                  <div>Student Name</div>
                                  <div>Registration Date</div>
                                </div>
                                {isTableDataLoading ? (
                                  <div className="modern-list-state">
                                    <ReactSpinner animation="border" />
                                  </div>
                                ) : filteredStudents.length > 0 ? (
                                  filteredStudents.map((stu) => (
                                    <div
                                      className="modern-list-row modern-grid modern-grid-3"
                                      key={stu.stu_id ?? stu.user_code}
                                    >
                                      <div>{stu.user_code ?? stu.stu_id}</div>
                                      <div>
                                        {`${stu.first_name ?? ""} ${
                                          stu.last_name ?? ""
                                        }`.trim()}
                                      </div>
                                      <div>
                                        {formatDate(stu.created_at)}{" "}
                                        <span style={{ color: "#3b82f6" }}>
                                          {formatTimeForSignUp(stu.created_at)}
                                        </span>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="modern-list-state">No data found</div>
                                )}
                              </div>
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={studentsDetails.totalStudentCount}
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={
                                  handleRowsPerPageChange
                                }
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[
                                  5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250,
                                  300,
                                ]}
                              />
                            </div>
                          </TabPane>
                        )}
                        {/*-----------------------------------------------Student Enroll Details------------------------------------------------- */}
                        {activeTab === "Student Enroll Details" && (
                          <TabPane
                            className="tab-pane fade show active"
                            id="manage-3"
                            ariaLabelledby="manage-tab-3"
                          >
                            {/* Table layout kept for reference
                            <Table>...</Table>
                            */}
                            <div className="modern-list-wrap">
                              <div className="modern-list modern-list-7">
                                <div className="modern-list-header modern-grid modern-grid-7">
                                  <div>Student ID</div>
                                  <div>Student Name</div>
                                  <div>Total Assessments</div>
                                  <div>Not Started</div>
                                  <div>In Progress</div>
                                  <div>Completed</div>
                                  <div>View Assessments</div>
                                </div>
                                {isTableDataLoading ? (
                                  <div className="modern-list-state">
                                    <ReactSpinner animation="border" />
                                  </div>
                                ) : filteredPapers.length > 0 ? (
                                  filteredPapers.map((pep) => (
                                    <div
                                      className="modern-list-row modern-grid modern-grid-7"
                                      key={pep.student_id ?? pep.user_code}
                                    >
                                      <div>{pep.user_code ?? pep.stu_id}</div>
                                      <div>
                                        {`${pep.first_name ?? ""} ${
                                          pep.last_name ?? ""
                                        }`.trim()}
                                      </div>
                                      <div>
                                        {(pep.assigned_count || 0) +
                                          (pep.finished_count || 0) +
                                          (pep.onprogress_count || 0)}
                                      </div>
                                      <div>{pep.assigned_count ?? 0}</div>
                                      <div>{pep.onprogress_count ?? 0}</div>
                                      <div>{pep.finished_count ?? 0}</div>
                                      <div>
                                        <Button
                                          className="btn btn-primary btn-sm m-1 px-3"
                                          title="View Assessments"
                                          onClick={() =>
                                            viewStudentAssessmentDetail(
                                              pep.student_id,
                                            )
                                          }
                                        >
                                          View Assessments
                                        </Button>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="modern-list-state">No data found</div>
                                )}
                              </div>
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={
                                  paperEnrolStatusCounts.totalPaperCount
                                }
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={
                                  handleRowsPerPageChange
                                }
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[
                                  5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250,
                                  300,
                                ]}
                              />
                            </div>
                          </TabPane>
                        )}
                        {/*-----------------------------------------------Paper Enroll Details------------------------------------------------- */}
                        {activeTab === "Paper Enroll Details" && (
                          <TabPane
                            className="tab-pane fade show active"
                            id="manage-4"
                            ariaLabelledby="manage-tab-4"
                          >
                            {/* Table layout kept for reference
                            <Table>...</Table>
                            */}
                            <div className="modern-list-wrap">
                              <div className="modern-list modern-list-4">
                                <div className="modern-list-header modern-grid modern-grid-4">
                                  <div>Assessment ID</div>
                                  <div>Assessment Title</div>
                                  <div>Enrolled Students</div>
                                  <div>View Students</div>
                                </div>
                                {isTableDataLoading ? (
                                  <div className="modern-list-state">
                                    <ReactSpinner animation="border" />
                                  </div>
                                ) : filteredStudentEnrolments.length > 0 ? (
                                  filteredStudentEnrolments.map((assessment) => (
                                    <div
                                      className="modern-list-row modern-grid modern-grid-4"
                                      key={assessment.assessment_id}
                                    >
                                      <div>
                                        {"ASMNT"}
                                        {assessment.assessment_id}
                                      </div>
                                      <div>{assessment.assess_name}</div>
                                      <div>{assessment.student_count}</div>
                                      <div>
                                        <Button
                                          className="btn btn-primary btn-sm m-1 px-3"
                                          title="Manage Students"
                                          onClick={() => {
                                            viewAssessmentStudentDetail(
                                              assessment.assessment_id,
                                            );
                                          }}
                                        >
                                          View Students
                                        </Button>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="modern-list-state">No data found</div>
                                )}
                              </div>
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={
                                  studentPaperEnrolment.totalAssessmentCount
                                }
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={
                                  handleRowsPerPageChange
                                }
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[
                                  5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250,
                                  300,
                                ]}
                              />
                            </div>
                          </TabPane>
                        )}
                        {/*-----------------------------------------------Assessment Feedback------------------------------------------------- */}
                        {activeTab === "Assessment Feedback" && (
                          <TabPane
                            className="tab-pane fade show active"
                            id="manage-5"
                            ariaLabelledby="manage-tab-5"
                          >
                            {feedback.feedbacks.length > 0 ? (
                              <div>
                                <div className="modern-list-wrap">
                                  <div className="modern-list modern-list-4">
                                    <div className="modern-list-header modern-grid modern-grid-4">
                                      <div>Assessment Code</div>
                                      <div>Assessment Title</div>
                                      <div>Feedback Count</div>
                                      <div>View</div>
                                    </div>
                                    {getUniqueAssessments().map((assessment) => (
                                      <div
                                        key={assessment.assessment_id}
                                        className="modern-list-row modern-grid modern-grid-4"
                                      >
                                        <div>ASMNT{assessment.assessment_id}</div>
                                        <div>{assessment.paper_title}</div>
                                        <div>{assessment.feedbackCount}</div>
                                        <div>
                                          <Button
                                            className="btn btn-primary btn-sm m-1 px-3"
                                            onClick={() =>
                                              handleAssessmentClick(assessment)
                                            }
                                          >
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                  <MaterialCustomTablePagination
                                    totalCount={feedback.totalFeedbackCount}
                                    currentPage={state.currentPage}
                                    limit={state.rowsPerPage}
                                    handlePageChange={handlePageChange}
                                    handleRowsPerPageChange={
                                      handleRowsPerPageChange
                                    }
                                    handlePageOffsetChange={
                                      handlePageOffsetChange
                                    }
                                    offset={state.offset}
                                    rowsPerPageOptions={[
                                      5, 10, 15, 20, 25, 50, 75, 100, 150, 200,
                                      250, 300,
                                    ]}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: "50vh" }}
                              >
                                <h5 className="text-muted">
                                  No feedback available.
                                </h5>
                              </div>
                            )}
                          </TabPane>
                        )}
                      </TabContent>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* this open if [assessmentModalShow=true] assesment details view in Student Enroll Details tab  */}
        {!modelDataLoding && (
          <Modal
            size="lg"
            centered
            dialogClassName="user-reports-action-modal"
            show={assessmentModalShow} ////////////////////////////////////
            onHide={() => setAssessmentModelShow(false)}
            backdrop="static" // prevent closing by clicking outside
            keyboard={false} // prevent closing by pressing ESC
          >
            <Modal.Header closeButton>
              <Modal.Title>Enrolled Assessment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <UserOwnPaper /> {/*cll function*/}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setAssessmentModelShow(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {/* this open if [open=true] assesment details view in Student Enroll Details tab  */}
        {!modelDataLoding && (
          <Modal
            size="lg"
            centered
            dialogClassName="user-reports-action-modal"
            show={studentModelShow} ////////////////////////////////////
            onHide={() => setStudentModelShow(false)}
            backdrop="static" // prevent closing by clicking outside
            keyboard={false} // prevent closing by pressing ESC
          >
            <Modal.Header closeButton>
              <Modal.Title>Enrolled Students</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AssessmentOwnStudents /> {/*cll function*/}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setStudentModelShow(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {/* Feedback Modal */}
        <Modal
          size="lg"
          centered
          dialogClassName="user-reports-action-modal"
          show={feedbackModalShow}
          onHide={() => {
            setFeedbackModalShow(false);
            setSelectedAssessment(null);
            setSelectedQuestion(null);
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedQuestion
                ? `Feedbacks for Question`
                : selectedAssessment
                ? `Questions for ${selectedAssessment.paper_title}`
                : "Feedback"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedQuestion ? (
              <div>
                <Button
                  variant="secondary"
                  onClick={() => setSelectedQuestion(null)}
                  className="mb-3"
                >
                  Back to Questions
                </Button>
                <h5> {selectedQuestion.question}</h5>

                {getFeedbacksForQuestion().length > 0 ? (
                  getFeedbacksForQuestion().map((fb) => (
                    <div
                      key={`${fb.student_id}-${fb.feedback_answer_option_id}-${fb.submitted_at}`}
                      className="mb-3 border p-2"
                    >
                      <strong>{fb.student_name}</strong> ({fb.student_id}):{" "}
                      {fb.answer_text ? (
                        <span>{fb.answer_text}</span>
                      ) : fb.answer ? (
                        <span
                          className={`feedback-option-chip ${getFeedbackOptionThemeClass(fb.answer)}`}
                        >
                          {fb.answer}
                        </span>
                      ) : (
                        <span>-</span>
                      )}
                      <br />
                      <small>
                        Submitted: {formatDate(fb.submitted_at)}{" "}
                        {formatTime(fb.submitted_at)}
                      </small>
                    </div>
                  ))
                ) : (
                  <p>No Responses</p>
                )}
              </div>
            ) : selectedAssessment ? (
              <div>
                {getQuestionsForAssessment(
                  selectedAssessment.assessment_id,
                ).map((q) => (
                  <div key={q.qus_id} className="card mb-2">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <strong> {q.question}</strong>
                        </p>
                        <Button
                          size="sm"
                          variant="link"
                          onClick={() => setSelectedQuestion(q)}
                        >
                          View Responses
                        </Button>
                      </div>
                      <small>Total feedbacks: {q.total}</small>
                      <div className="mt-2 feedback-option-chips">
                        {q.options.length > 0 ? (
                          q.options.map((opt) => (
                            <span
                              key={opt.fb_qus_ans_opt_id}
                              className={`feedback-option-chip ${getFeedbackOptionThemeClass(opt.ans_option)}`}
                            >
                              {opt.ans_option} : {opt.count}
                            </span>
                          ))
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setFeedbackModalShow(false);
                setSelectedAssessment(null);
                setSelectedQuestion(null);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </ContentWrapper>
    </div>
  );
}

export default UserReports;
